import { __decorate } from "tslib";
import { id_ntQWAC } from "./oids";
import { AsnType, AsnTypeTypes, AsnProp, AsnPropTypes } from "@peculiar/asn1-schema";
export const id_InsuranceValue = `${id_ntQWAC}.8`;
let InsuranceValue = class InsuranceValue {
    constructor(params = {}) {
        this.location = "";
        this.base = 0;
        this.degree = 0;
        Object.assign(this, params);
    }
    toString() {
        return `${this.base} x 10^${this.degree} ${this.location}`;
    }
};
__decorate([
    AsnProp({ type: AsnPropTypes.PrintableString })
], InsuranceValue.prototype, "location", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.Integer })
], InsuranceValue.prototype, "base", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.Integer })
], InsuranceValue.prototype, "degree", void 0);
InsuranceValue = __decorate([
    AsnType({ type: AsnTypeTypes.Sequence })
], InsuranceValue);
export { InsuranceValue };
